import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

// import './App.css';
import "./assets/scss/style.scss?v=1.3.0";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/scss/paper-dashboard.scss?v=1.3.0";
import "./assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "simplebar/dist/simplebar.min.css";

const history = createBrowserHistory();

ReactDOM.render(
  <Router history={history}>
    <App />
    <ToastContainer autoClose={5000} hideProgressBar={true} />
  </Router>,
  document.getElementById("root")
);

serviceWorker.unregister();
